import axios from 'axios';

// Much of this is borrowed from Azure documentation.

export const fetchStorageAccountToken = async (fileType) => {
    try { 
        const { data: token } = await axios.post('/auth/user/sas-token', {fileType});

        return token;
    } catch (err) {
        console.error(`Error generating SAS token: ${err.message}`);
    }
};
